class CarouselText extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.index = 0;
    this.timer = null;
    this.isAnimating = false; // 控制节流
  }

  connectedCallback() {
    let textList = [];
    if (this.getAttribute('text')) {
      const arr = this.getAttribute('text')
        .replace(/'/g, '"')  // 将单引号替换为双引号
        .trim();

      textList = JSON.parse(arr); // ["One", "Two", "Three", "Four", "Five"]
    }
    this.visibleCount = parseInt(this.getAttribute('visible-count') || '1', 10);
    this.speed = parseInt(this.getAttribute('speed') || '500', 10);
    this.duration = parseInt(this.getAttribute('duration') || '2000', 10);
    this.autoplay = this.hasAttribute('autoplay');
    // this.loop = this.hasAttribute('loop');
    this.showArrows = this.hasAttribute('show-arrows');

    // duplicate for seamless loop
    this.textList = [
      ...textList.slice(-this.visibleCount),
      ...textList,
      ...textList.slice(0, this.visibleCount)
    ];
    this.index = this.visibleCount;

    this.render();
    this.updatePosition(0);
    if (this.autoplay && textList.length > 1) this.start();
  }

  render() {
    const style = `
      <style>
        :host {
          display: block;
          overflow: hidden;
          user-select: none;
        }
        .carousel-text__container {
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }
        .arrow {
          color: black;
          border: none;
          padding: 0.5rem;
          cursor: pointer;
          z-index: 2;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .arrow svg {
          height: 20px;
        }
        .track-wrapper {
          overflow: hidden;
          flex: 1;
        }
        .track {
          display: flex;
          transition: transform ${this.speed}ms ease;
          will-change: transform;
        }
        .item {
          flex: 0 0 ${100 / this.visibleCount}%;
          box-sizing: border-box;
          padding: 0 10px;
          text-align: center;
          font-size: 14px;
          // white-space: nowrap;
          line-height: 1.1;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          color: inherit;
        }
      </style>
    `;

    const items = this.textList
      .map((text) => text.match(/\(.*?\)/) ? `<a class="item" href="${text.match(/\(.*?\)/)[0].slice(1, -1)}">${text.match(/^(.*?)\(/)[1]}</a>`  : `<div class="item">${text}</div>`)
      .join('');

    const html = `
      ${style}
      <div class="carousel-text__container">
        ${this.showArrows ? `<div class="arrow left">
         <svg fill="currentColor" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
          <path d="M238.475 36.465l7.071 7.07c4.686 4.686 4.686 12.284 0 16.971L50.053 256l195.493 195.494c4.686 4.686 4.686 12.284 0 16.971l-7.071 7.07c-4.686 4.686-12.284 4.686-16.97 0L21.475 264.485c-4.686-4.686-4.686-12.284 0-16.971L221.505 36.465c4.686-4.687 12.284-4.687 16.97 0z"/>
        </svg>
        </div>` : ''}
        <div class="track-wrapper">
          <div class="track">${items}</div>
        </div>
        ${this.showArrows ? `<div class="arrow right">
          <svg fill="currentColor" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"/></svg>
        </div>` : ''}
      </div>
    `;

    this.shadowRoot.innerHTML = html;
    this.track = this.shadowRoot.querySelector('.track');

    if (this.showArrows) {
      this.leftArrow = this.shadowRoot.querySelector('.arrow.left');
      this.rightArrow = this.shadowRoot.querySelector('.arrow.right');
      this.leftArrow.addEventListener('click', () => this.prev());
      this.rightArrow.addEventListener('click', () => this.next());
    }
  }

  updatePosition(transitionTime = this.speed) {
    if (!this.track) return;
    const percent = -(100 / this.visibleCount) * this.index;
    this.track.style.transition = `transform ${transitionTime}ms ease`;
    this.track.style.transform = `translateX(${percent}%)`;
  }

  next() {
    if (this.isAnimating) return;
    this.isAnimating = true;

    this.index++;
    this.updatePosition();

    if (this.index >= this.textList.length - this.visibleCount) {
      setTimeout(() => {
        this.track.style.transition = 'none';
        this.index = this.visibleCount;
        this.updatePosition(0);
        this.isAnimating = false;
      }, this.speed);
    } else {
      setTimeout(() => {
        this.isAnimating = false;
      }, this.speed);
    }
  }

  prev() {
    if (this.isAnimating) return;
    this.isAnimating = true;

    this.index--;
    this.updatePosition();

    if (this.index < this.visibleCount) {
      setTimeout(() => {
        this.track.style.transition = 'none';
        this.index = this.textList.length - this.visibleCount * 2;
        this.updatePosition(0);
        this.isAnimating = false;
      }, this.speed);
    } else {
      setTimeout(() => {
        this.isAnimating = false;
      }, this.speed);
    }
  }

  start() {
    this.timer = setInterval(() => this.next(), this.duration);
  }

  stop() {
    clearInterval(this.timer);
  }

  disconnectedCallback() {
    this.stop();
  }
}

customElements.define('carousel-text', CarouselText);
